import { render, staticRenderFns } from "./DashboardSingleInfoCard.vue?vue&type=template&id=3472b3bd&scoped=true&"
import script from "./DashboardSingleInfoCard.vue?vue&type=script&lang=js&"
export * from "./DashboardSingleInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSingleInfoCard.vue?vue&type=style&index=0&id=3472b3bd&lang=scss&scoped=true&"
import style1 from "./DashboardSingleInfoCard.vue?vue&type=style&index=1&id=3472b3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472b3bd",
  null
  
)

export default component.exports